//
//
//
//
//
//

import DropItem from './DropItem.vue';
export default {
    components: {
        DropItem
    },
    props: ['dropdown', "extend", "executeSearch", "clearPreviousItemResults"],
    computed: {
        model: {
            get() {
                return this.dropdown.values.find(i => i.selected).value;
            },
            set(val) {
                this.extend(extended => {
                    extended.dropdowns
                        .find(d => d.id === this.dropdown.id)
                        .values.forEach(i => {
                            if (i.value === val) return i.selected = true;
                            i.selected = false;
                        });
                    return extended;
                })
                this.clearPreviousItemResults();
                this.executeSearch();
            }
        }
    }
}
